define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/xml/Query",
	"csi/table/AggregateFrom"
], function(declare,xml,Query,AggregateFrom) {

	return declare(AggregateFrom, {

		_getFixedFilters: function() {
			return new Query().RefAttr("Subtype", xml.OP_EQUALS, this.widget.urlSecondaryType).getElements();
		},

		toWriterRequest: function(/*FormData?*/fd) {
			var call = this.inherited(arguments);
			call.addParameter("Subtype", xml.ATTR_REF, this.widget.urlSecondaryType);
			return call;
		}
	});
});